module.exports = __webpack_public_path__ + "img/1F1E6-1F1EA.36594897.svg";